import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AuthRedirectorService } from '../auth/auth-redirector.service';
import { StateService } from '../../state/state.service';

@Injectable()
export class PanelTypeGuard implements CanActivate, CanLoad {
  constructor(private router: Router,
    private state: StateService,
    private redirector: AuthRedirectorService) {
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (!environment.production && route.queryParams.skipRouteGuard) {
      return true;
    }
    let canActivate = false;

    const acl = this.state.snapshot.auth.acl;
    const path = route.url[0].path;

    if (acl.length) {
      if ((acl[0] === 'shp' && path === 'shop') || (acl[0] === 'lab' && path === 'lab') || (acl[0] === 'adm' && path === 'admin') || (acl[0] === 'agn' && path === 'agent') || (acl[0] === 'cli' && path === 'client') || (acl[0] === 'mshp' && path === 'mshp') || (acl[0] === 'cov' && path === 'cover')) {
        canActivate = true;
      }
    }

    return canActivate;
  }

  canLoad(route: Route): boolean {
    if (!this.state.snapshot.auth.isAuthenticated) {
      this.redirector.redirect();

      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/service/panel-type-guard.ts